import { readStorage, writeStorage } from '@/utils/storage/base'

const getSessionStorage = () => {
  if (typeof window === 'undefined') return null
  return window.sessionStorage
}

const buildJobProfileKey = (jobId: string) => `job-profile:${jobId}`

export const jobProfileStorage = {
  get: (jobId: string) => {
    const normalizedJobId = String(jobId || '').trim()
    if (!normalizedJobId) return ''
    return readStorage(buildJobProfileKey(normalizedJobId), '', getSessionStorage()) || ''
  },
  set: (jobId: string, profile: string) => {
    const normalizedJobId = String(jobId || '').trim()
    const normalizedProfile = String(profile || '').trim()
    if (!normalizedJobId || !normalizedProfile) return
    writeStorage(buildJobProfileKey(normalizedJobId), normalizedProfile, getSessionStorage())
  },
}
